"use client";

import type { DetailedOwnListing } from "@/lib/types";
import { createContext, useContext } from "react";

export type CreateAsParams = {
  userId: string;
  opportunityId: number;
};

export type SellerAgentParams = {
  userId: string;
  opportunityId: number;
};

export type NewListingButtonContext = {
  isDisabled: boolean;
  createListing: (
    createAs: CreateAsParams | undefined,
    sellerAgent: SellerAgentParams | undefined,
    onListingCreated: (listing: DetailedOwnListing) => void | Promise<void>,
  ) => Promise<void>;
};

export const newListingButtonContext = createContext<NewListingButtonContext>({
  isDisabled: false,
  createListing: async () => void 0,
});

export function useNewListingButton() {
  const context = useContext(newListingButtonContext);
  return context;
}
